import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import HeadingPropTypes from '../definitions/HeadingPropTypes';
import HeadingBlock from './HeadingBlock';


const VARIANTS = {
    LIGHT: 'light',
    DARK: 'dark',
};

function AccordionContainer({
    heading,
    variant = VARIANTS.DARK,
    hasMaxWidth = true,
    className,
    children,
}) {
    return (
        <div
            className={classNames('rh-mx-auto', {
                'rh-max-width-800px': hasMaxWidth,
            }, className)}
        >
            <HeadingBlock
                variant={variant}
                {...heading}
            />

            {children}
        </div>
    );
}

AccordionContainer.propTypes = {
    heading: HeadingPropTypes,
    variant: PropTypes.oneOf(Object.values(VARIANTS)),
    hasMaxWidth: PropTypes.bool,
    className: PropTypes.string,
    children: PropTypes.any.isRequired,
};

AccordionContainer.blockKey = 'rh/accordion-container';
AccordionContainer.hasHeading = true;
AccordionContainer.requiresLayoutRow = true;


export default AccordionContainer;
